/* eslint-disable max-len */
import { Box, Typography } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { makeStyles, alpha } from '@material-ui/core/styles';
import { withTranslation } from 'config/i18n';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';

const useStyles = makeStyles((theme) => ({
  IPphoneNumber: {
    position: 'relative',
    '& .intl-tel-input.allow-dropdown': {
      width: '100%',
      '& input[type="tel"]': {
        height: theme.typography.pxToRem(56),
        borderRadius: '4px',
        border: `1px solid ${alpha(theme.palette.common.black, 0.23)}`,
        width: '100%',
        paddingLeft: theme.typography.pxToRem(60),
        fontSize: theme.typography.pxToRem(16),
        '&:focus-visible,&:focus': {
          border: `1px solid ${theme.palette.primary.main}`,
          outline: `1px solid ${theme.palette.primary.main}`,
          fontSize: '16px',
        },
      },

      '& .selected-flag': {
        borderRight: `1px solid ${alpha(theme.palette.common.black, 0.23)}`,
        width: theme.typography.pxToRem(52),
      },
      '& .arrow': {
        fontSize: theme.typography.pxToRem(9.5),
      },
    },
    '& .arrow': { pointerEvents: 'none' },
  },
  IPvalid: {
    color: theme.palette.success.main,
  },
  IPinvalid: {
    color: theme.palette.error.main,
  },
  IPicon: {
    position: 'absolute',
    right: theme.typography.pxToRem(12),
    top: theme.typography.pxToRem(15),
  },
}));

const InternationalPhone = (props) => {
  const classes = useStyles();
  const { t, data, handleChange, error, helperText, inputDataTestId } = props;
  const [validPhone, setValidPhone] = useState();

  const handlePhoneNumberChange = (value, number, countryData, status) => {
    const regex = /[a-zA-Z!@#$%^&*_+=[\]{};':"\\|,.<>/?]/;
    if (!data?.skipValidation && regex.test(value)) return;
    handleChange({
      value,
      number,
      countryCode: countryData.iso2,
      phoneCode: countryData.dialCode,
      status,
    });
  };
  const handleCountrySelect = (value, countryData, number, status) => {
    const regex = /[a-zA-Z!@#$%^&*_+=[\]{};':"\\|,.<>/?]/;
    if (regex.test(value)) return;
    handleChange({
      value,
      number,
      countryCode: countryData.iso2,
      phoneCode: countryData.dialCode,
      status,
    });
  };

  useEffect(() => {
    if (error) {
      setValidPhone(false);
    }
  }, [error]);

  return (
    <Box className={classes.IPphoneNumber}>
      <IntlTelInput
        autoComplete="tel"
        format
        disabled={data.disabled}
        onSelectFlag={handleCountrySelect}
        defaultCountry={data.country_code?.toLowerCase() || 'us'}
        value={data.phone || ''}
        onPhoneNumberChange={(status, value, countryData, number) =>
          handlePhoneNumberChange(value, number, countryData, status)
        }
        telInputProps={{
          ...(inputDataTestId ? { 'data-testid': inputDataTestId } : {}),
        }}
      />
      {(data.validPhone === true || validPhone === true) && (
        <Box className={[classes.IPvalid, classes.IPicon]}>
          <CheckIcon />
        </Box>
      )}
      {(data.validPhone === false || (validPhone === false && data.validPhone !== true)) && (
        <>
          <Box className={[classes.IPinvalid, classes.IPicon]}>
            <CloseIcon />
          </Box>
          <Typography variant="h6" component="p" className={classes.IPinvalid}>
            {helperText || t('fe_es_identity_verification:in_valid_phone_number')}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default withTranslation('fe_es_identity_verification')(InternationalPhone);
